





















































































































import { Component, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import ModalAddress from '@/components/manageGroup/addresses/ModalAddress.vue';
import MobileAddressCard from '@/components/manageGroup/addresses/MobileAddressCard.vue';

import * as s_Interface from '@/interface/store/manageGroups';

const namespace: string = 'manageGroup';

@Component({
  components: {
    ModalAddress,
    MobileAddressCard,
  },
})
export default class Addresses extends Vue {
  @PropSync('dialogVisible', { type: Boolean }) syncedDialogVisible!: boolean;

  @Action('getAddresses', { namespace }) c_getAddresses!: any;
  @Action('setAddress', { namespace }) c_setAddress!: any;
  @Action('deleteAddress', { namespace }) c_deleteAddress!: any;
  @Action('updateAddress', { namespace }) c_updateAddress!: any;
  @Action('getMe', { namespace }) c_getMe!: any;

  @Getter('getterAddresses', { namespace }) c_getterAddresses!: Array<s_Interface.Addresses>;
  @Getter('getterMe', { namespace }) c_getterMe!: any;

  public isAdmin: boolean = true;
  public selectIdx: any = [];
  public addressMode: string = 'add';
  public updateAddressId: string = '';

  async created() {
    try {
      await this.initGetAddresses();
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  @Watch('$route.params.groupId')
  async onGroupIdChange(groupId: string, oldGroupId: string) {
    try {
      await this.initGetAddresses();
      await this.c_getMe(groupId);
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  async initGetAddresses(): Promise<any> {
    const groupId: string = this.$route.params.groupId;
    try {
      await this.c_getAddresses(groupId);
    } catch (e) {
      console.log(e);
    }
  }

  addAddressOpen(mode: string, updateAddressId?: string): void {
    this.syncedDialogVisible = true;
    this.addressMode = mode;
    if (updateAddressId !== undefined) this.updateAddressId = updateAddressId;
  }

  onModalClose(bool: boolean): void {
    this.syncedDialogVisible = bool;
  }

  async deleteAddress(item: any): Promise<any> {
    this.$confirm(`정말 '${item.organization}' 배송지를 삭제하시겠습니까?`, `배송지 삭제`, {
      confirmButtonText: '삭제하기',
      cancelButtonText: '취소',
      type: 'warning',
    })
      .then(async () => {
        const groupId: string = this.$route.params.groupId;
        await this.c_deleteAddress({
          groupId,
          addressId: item.id,
        });
        await this.initGetAddresses();
        this.$message.success(`'${item.organization}' 배송지를 삭제하였습니다.`);
      })
      .catch((e) => {
        console.log(e);
        this.$message.error(e.response.data.error.message);
      });
  }

  async onUpdateSubmit(bool: boolean): Promise<any> {
    try {
      await this.initGetAddresses();
      this.syncedDialogVisible = bool;
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }
}
